import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import type { Nullable } from '@ps/utils';
import { SupplierApi } from '../api/supplier.api';
import { Supplier, SupplierAccessSave } from '../models/supplier.model';

@Injectable({ providedIn: 'root' })
export class SupplierService {
  private readonly _api = inject(SupplierApi);

  public getAll(
    buyerId: number,
    countryId?: Nullable<number>,
    languageId?: Nullable<number>,
  ): Observable<Supplier[]> {
    return this._api.getAll(buyerId, countryId, languageId);
  }

  public saveAccess(data: SupplierAccessSave): Observable<void> {
    return this._api.saveAccess(data).pipe(map(() => undefined));
  }
}
